// extracted by mini-css-extract-plugin
export default {"one":"SecOne_one__b2XxA","main":"SecOne_main__avQkD","gif":"SecOne_gif__1lBTQ"};